import { render, staticRenderFns } from "./DashboardTaskPanelTile.vue?vue&type=template&id=9dd874b8&scoped=true"
import script from "./DashboardTaskPanelTile.vue?vue&type=script&lang=js"
export * from "./DashboardTaskPanelTile.vue?vue&type=script&lang=js"
import style0 from "./DashboardTaskPanelTile.vue?vue&type=style&index=0&id=9dd874b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9dd874b8",
  null
  
)

export default component.exports